import { Region, State } from 'utils/constants/location';
/**
 * Shared preset filter keys used by:
 * - Filter toolbar: "Preset for GCs" / "Preset for Subs" buttons
 * - Onboarding wizard: "I'm a General Contractor" / "I'm a Subcontractor" role step
 * When presets are updated in the backend, both flows use the same API and stay in sync.
 */
const PRESET_FILTER_KEYS = {
  GENERAL_CONTRACTORS: 'PRESET_FOR_GENERAL_CONTRACTORS',
  SUB_CONTRACTORS: 'PRESET_FOR_SUB_CONTRACTORS',
} as const;

export const PRESET_FILTERS = [
  { key: PRESET_FILTER_KEYS.GENERAL_CONTRACTORS, label: 'Preset for GCs' },
  { key: PRESET_FILTER_KEYS.SUB_CONTRACTORS, label: 'Preset for Subs' },
] as const;

/** Map onboarding wizard role id to preset filter key */
export const ROLE_ID_TO_PRESET_KEY: Record<string, string> = {
  general_contractor: PRESET_FILTER_KEYS.GENERAL_CONTRACTORS,
  subcontractor: PRESET_FILTER_KEYS.SUB_CONTRACTORS,
};

/**
 * This a HACK!
 * Presets used to be by region, but now they are separated by states.
 * Returns region based on selected state.
 * Currently only supports TX and FL.
 */
export const getRegionFromSelectedState = (
  selectedState: State | null,
): Region | null => {
  if (selectedState === State.TX) {
    return Region.US_AUSTIN;
  }
  if (selectedState === State.FL) {
    return Region.US_MIAMI;
  }
  if (selectedState === State.IN) {
    return Region.US_INDIANAPOLIS;
  }

  return null;
};
